import { Grid, Paper, Skeleton, Stack, Tab, Tabs, Typography } from '@mui/material';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import { RevenueExpenseDetailsTableHeader, TABS } from './utils/RevenueExpenseDetailsPageHelper';
import { useEffect, useMemo, useState } from 'react';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import FromAndToDatePicker from '../../../../components/mui/FromAndToDatePicker';
import { useDispatch } from 'react-redux';
import { getRevenueOrExpenseAnalysis } from '../../../../redux/features/dashboardSlice';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import GlobalTableGenerator from '../../../../components/GlobalTableGenerator';
import { useSearchParams } from 'react-router-dom';

export default function RevenueExpenseDetails() {
  const [tab, setTab] = useState('interval');
  const [fromDate, setFromDate] = useState(dayjs().startOf('month').format('YYYY-MM-DD'));
  const [toDate, setToDate] = useState(dayjs().endOf('month').format('YYYY-MM-DD'));
  const [cardClick, setCardClick] = useState({ deptId: null, index: null });
  const [searchParams, setSearchParams] = useSearchParams();

  const dispatch = useDispatch();

  // query
  const queryName = useMemo(() => searchParams.get('name'), [searchParams]);

  useEffect(() => {
    const params = {
      company: tab,
      startDate: fromDate,
      endDate: toDate,
      urlPath: queryName === 'Revenue' ? 'revenue' : 'expense',
    };
    const revenueOfExpenseAnalaysisSignal = dispatch(getRevenueOrExpenseAnalysis(params));
    return () => {
      revenueOfExpenseAnalaysisSignal.abort();
    };
  }, [tab, dispatch, fromDate, toDate, queryName]);

  const revenueOfExpenseAnalysisData = useSelector((state) => state.dashboard.revenueOrExpenseAnalysis.data);
  const revenueOfExpenseAnalysisDataLoading = useSelector((state) => state.dashboard.revenueOrExpenseAnalysis.loading);

  return (
    <GlobalWrapper title={queryName}>
      <Stack gap={3}>
        <Stack direction={{ sm: 'column', md: 'row' }} justifyContent={'space-between'} gap={2}>
          <Tabs
            value={tab}
            onChange={(_, v) => setTab(v)}
            sx={{
              '& .Mui-selected': {
                bgcolor: '#6465f4',
                color: 'white !important',
                borderRadius: 4,
              },
            }}
            indicatorColor="none"
          >
            {TABS.map(({ id, label, value }) => (
              <Tab label={label} key={id} value={value} sx={{ fontSize: '1rem' }} />
            ))}
          </Tabs>
          <FromAndToDatePicker {...{ fromDate, toDate, setFromDate, setToDate }} />
        </Stack>
        <Paper elevation={3} sx={{ p: 4, border: '1px solid #dbdbdbff' }}>
          <Typography variant="body2" color={'#868686ff'}>
            Total Revenue
          </Typography>

          <Typography color={'#1cb07e'} variant="h2">
            {revenueOfExpenseAnalysisDataLoading ? <Skeleton /> : `₹${revenueOfExpenseAnalysisData?.total}`}
          </Typography>
        </Paper>
        <Typography variant="h6">
          {tab === 'interval' ? 'Projects' : 'Courses'} {queryName}
        </Typography>
        <Grid container spacing={2}>
          {revenueOfExpenseAnalysisDataLoading
            ? Array.from({ length: 4 }).map((_, index) => (
                <Grid item width={'100%'} key={index} xs={12} sm={6} md={3}>
                  <Skeleton width={'100%'} height={180} />
                </Grid>
              ))
            : revenueOfExpenseAnalysisData?.departments?.map(({ deptId, depTName, total }, index) => (
                <Grid item width={'100%'} key={deptId} xs={12} sm={6} md={3}>
                  <Paper
                    onClick={() => setCardClick({ deptId, index })}
                    elevation={3}
                    sx={{
                      cursor: 'pointer',
                      p: 3,
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 2,
                      border: cardClick.deptId === deptId ? '0.5px solid #6465f4' : '',
                      position: 'relative',
                      width: '100%',
                      ':hover': { boxShadow: 'rgba(0, 0, 0, 0.22) 0px 5px 13px' },
                    }}
                  >
                    <Typography fontWeight={700}>{depTName.replace(/[^a-zA-Z0-9]/g, ' ')}</Typography>
                    <Typography color={'#1cb07e'} variant="h5">
                      {total}
                    </Typography>
                    <ArrowForwardIosIcon
                      sx={{ width: 15, height: 15, position: 'absolute', right: 15, top: 15, color: '#a5a7aa' }}
                    />
                  </Paper>
                </Grid>
              ))}
        </Grid>
        {cardClick.deptId != null && (
          <GlobalTableGenerator
            TableHeadStyle={{ bgcolor: '#c6c7c9ff' }}
            rows={revenueOfExpenseAnalysisData?.departments?.[cardClick.index]?.courses || []}
            columns={RevenueExpenseDetailsTableHeader}
            loading={revenueOfExpenseAnalysisDataLoading}
            pagination
          />
        )}{' '}
      </Stack>
    </GlobalWrapper>
  );
}
